import { request } from "../request";

export type MaterialType = {
  id: string;
  url: string;
  name: string;
  flowId: string;
};

export type MaterialParamsType = {
  maxUploadTime?: string;
  minUploadTime?: string;
  name?: string;
  pageNum: number;
  pageSize: number;
  flowId: string;
};
/**
 * 查询素材
 * @param data
 * @returns
 */
export function queryMaterialPageService(data: MaterialParamsType) {
  return request<
    API.BaseResponse<{
      records: MaterialType[];
      total: number;
      size: number;
      success: boolean;
    }>
  >("/api/knowledge-base-management/material/page", {
    method: "POST",
    data,
  });
}
